import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text = '¡SÍ, QUIERO MI PROTOCOLO AHORA POR $6.39!',
  href = '#cta-final',
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const targetId = href.slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <div className={`flex flex-col items-center w-full max-w-md mx-auto ${className}`} data-id="element-14">
      <a href={href} onClick={handleClick} className="w-full bg-orange-600 hover:bg-orange-500 text-white font-bold text-lg md:text-xl py-4 px-6 rounded-xl shadow-[0_8px_0_rgb(194,65,12)] hover:shadow-[0_4px_0_rgb(194,65,12)] hover:translate-y-1 transition-all duration-200 text-center uppercase tracking-wide cursor-pointer" data-id="element-15">
        {text}
      </a>
      <div className="flex items-center gap-2 mt-4 text-sm text-gray-600 font-medium" data-id="element-16">
        <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-17" />
        <span data-id="element-18">Acceso inmediato tras el pago • Seguro y Protegido</span>
      </div>
    </div>;
}